import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
export function useMembers() {
  const [m, setM] = useState(cache || []);
  useEffect(() => { if (!cache) api.get("/team/members").then((r) => { cache = r.data; setM(r.data); }).catch(() => {}); }, []);
  return m;
}

export default function AssigneeSelect({ value, onChange, testid = "select-appt-assignee", placeholder = "Non attribué", className = "" }) {
  const members = useMembers();
  return (
    <select data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value || null)} className={`h-10 w-full rounded-md border border-slate-200 bg-slate-50 px-3 text-sm ${className}`}>
      <option value="">{placeholder}</option>
      {members.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
    </select>
  );
}
